import { pdfjs } from 'react-pdf';

import { CONFIG } from "../config/const"

const { CDN_BASE_URL } = CONFIG;

// Configure PDF.js worker
// ---------------------
pdfjs.GlobalWorkerOptions.workerSrc = `${CDN_BASE_URL}/js/pdf-worker/pdf.worker.min.mjs`;